import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import { getStoredToken, removeStoredToken } from 'src/utils/auth';

function setupRequest() {
    function onResponse(response: AxiosResponse) {
        if (response.status === 401) {
            removeStoredToken();
        }
        return response
    }

    function onResponseError(error: AxiosError): Promise<AxiosError> {
        if (error.response?.status === 401) {
            removeStoredToken();

            if (!window.location.href.includes("/login")) {
                window.location.href = "/login"
            }
        }
        return Promise.reject(error);
    }

    function onRequest(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
        const token = getStoredToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }

        return config;
    }

    function onRequestError(error: AxiosError): Promise<AxiosError> {
        return Promise.reject(error);
    }

    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_BACKEND_URL
    });

    axiosInstance.interceptors.response.use(onResponse, onResponseError);
    axiosInstance.interceptors.request.use(onRequest, onRequestError);

    return axiosInstance;
}

export const request = setupRequest();

export type CreatedResponse = {
    id: number|string;
}
